module.exports = __webpack_public_path__ + "static/media/IconHeart.74c2e11d.svg";